import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const WaterColourList = Loadable(lazy(() => import("./WaterColourList")));
const WaterColourForm = Loadable(lazy(() => import("./WaterColourForm")));

const waterColourRoutes = [
  {
    path: "/WaterColour/WaterColourList",
    element: <WaterColourList />,
    permission: PERMISSIONS.WaterColour.Menu,
  },
  {
    path: "/WaterColour/WaterColourForm",
    element: <WaterColourForm />,
  },
  {
    path: "/WaterColour/WaterColourForm/:waterColourId",
    element: <WaterColourForm />,
  },
];

export default waterColourRoutes;
